<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :items-per-page="15"
    class="elevation-1"
    hide-default-footer
    item-key="date"
  >
    <template v-slot:item.serviceType="{item}">
      <v-icon>{{supplierTypeIcon(item.serviceType)}}</v-icon>
    </template>
  </v-data-table>
</template>

<script>
import { SupplierTypeIconMixin } from "../../../../mixins/SupplierTypeIconMixin";
export default {
  name: "template-items-grid",
  props: {
    value: { type: Array, default: () => [] }
  },
  mixins: [SupplierTypeIconMixin],
  data() {
    return {
      headers: [
        {
          text: "Type",
          value: "serviceType",
          sortable: true,
          name: "serviceType"
        },
        {
          text: "Day",
          value: "day",
          sortable: true,
          name: "day"
        },
        {
          text: "Duration",
          value: "duration",
          sortable: true,
          name: "duration"
        },
        {
          text: "Supplier",
          value: "supplierName",
          sortable: true,
          name: "supplierName"
        },
        {
          text: "Service Name",
          value: "serviceName",
          sortable: true,
          name: "serviceName"
        }
      ]
    };
  },
  computed: {
    items() {
      return this.value && this.value.length
        ? this.value.map(item => ({
            day: item.node.day,
            duration: item.node.duration,
            serviceType: item.node.supplier.serviceType,
            serviceName: item.node.service.name,
            supplierName: item.node.supplier.name
          }))
        : [];
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/ItineraryBuilderItemQuickAddTemplateItems.vue